import { v4 } from 'uuid';
// For some reason its really hard to mock the uuid module directly,
// so using this wrapper will all us to mock it in tests with low impact on code
export function uuid() {
    return v4();
}
